import { render } from "./UserBehaviorTracking.vue?vue&type=template&id=fa2e9420"
import script from "./UserBehaviorTracking.vue?vue&type=script&lang=js"
export * from "./UserBehaviorTracking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__